import { render, staticRenderFns } from "./CarrinhoEmpresaAgrupamento.vue?vue&type=template&id=6e31aa4b"
import script from "./CarrinhoEmpresaAgrupamento.vue?vue&type=script&lang=js"
export * from "./CarrinhoEmpresaAgrupamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports